import React, {useContext} from "react";
import {StateContext, DispatchContext} from "./context";

export function useState() {
    let state = useContext(StateContext);
    let dispatch = useContext(DispatchContext);

    return [state, dispatch];
}